type Props = {
  email?: string | null;
  cognitoId?: string | null;
};

export default function ImpersonationBanner({ email, cognitoId }: Props) {
  const label = email || cognitoId || "student";

  return (
    <div className="sticky top-0 z-[100] bg-amber-500 text-black text-center text-sm font-medium px-4 py-2">
      Impersonating {label}
      {" · "}
          Clear via{" "}
          <code className="text-xs">
            /api/dev/impersonate/?secret=...&clear=1
          </code>
    </div>
  );
}
